export default "__VITE_ASSET__GrEcH0Y9__";